"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealDate = exports.convertDurationToText = exports.getRelativeTime = exports.rawPersianToEpoch = exports.compareDateType = exports.formatEpoch = exports.isYesterday = exports.isToday = exports.isDateFor30DaysAgo = exports.isDateFirstDayOfMonth = exports.isDateToday = exports.getDiffrenceTwoTime = exports.getDateType = exports.isYearAgo = exports.isMonthAgo = exports.DateTimeType = exports.delayReject = exports.delay = exports.formatTimeDuration = exports.SecondsInDay = exports.formatSeconds = exports.isTodayLastDayOfMonth = exports.getLocalDateChat = exports.getLocalDateObject = exports.getCompleteLocalDateTime = exports.getLocalDateTimeDialog = exports.getMonthDays = exports.getSaturdayDate = exports.isLeapYear = exports.getJalaliDateObject = exports.getCurrentTime = exports.getLocalTimeHoursMinutes = exports.getLocaleDateTime = exports.getLocalTime = exports.SECONDS_PASSED_IN_A_YEAR = exports.OneMonthInMS = exports.OneWeekInMS = exports.OneDayInMS = exports.OneHourInMS = exports.OneMinuteInMS = exports.OneSecondInMS = void 0;
exports.isSecondsElapsedFrom = isSecondsElapsedFrom;
exports.getTodayDate = getTodayDate;
exports.toGregorian = toGregorian;
exports.jalaliCurrentDate = jalaliCurrentDate;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.epochToJalai = epochToJalai;
exports.epochToDateType = epochToDateType;
exports.jalaliToEpoch = jalaliToEpoch;
exports.isFirstDateGraterThanSecondDate = isFirstDateGraterThanSecondDate;
exports.formatJalaliDate = formatJalaliDate;
exports.getRelativeDate = getRelativeDate;
const jalaali_js_1 = __importDefault(require("jalaali-js"));
const fa_1 = require("./fa");
const strings_1 = require("./strings");
const numbers_1 = require("./numbers");
exports.OneSecondInMS = 1000;
exports.OneMinuteInMS = 60 * exports.OneSecondInMS;
exports.OneHourInMS = 60 * exports.OneMinuteInMS;
exports.OneDayInMS = exports.OneHourInMS * 24;
exports.OneWeekInMS = exports.OneDayInMS * 7;
exports.OneMonthInMS = exports.OneDayInMS * 30;
exports.SECONDS_PASSED_IN_A_YEAR = (365 * exports.OneDayInMS) / 1000;
const intlDateTimeFormat = new Intl.DateTimeFormat("fa-IR");
const intlDateTimeFormatShortComplete = Intl.DateTimeFormat("fa-IR", {
    //todo: fix
    // @ts-ignore
    timeStyle: "medium",
    dateStyle: "short",
});
const intlDateTimeFormatYMD = new Intl.DateTimeFormat("fa-IR", {
    day: "numeric",
    month: "long",
    year: "numeric",
});
const intlDateTimeFormatHM = new Intl.DateTimeFormat("fa-IR", {
    hour: "numeric",
    minute: "numeric",
});
const getLocalTime = (timestamp) => {
    return intlDateTimeFormat.format(timestamp);
};
exports.getLocalTime = getLocalTime;
const getLocaleDateTime = (timestamp) => {
    return intlDateTimeFormatShortComplete.format(timestamp);
};
exports.getLocaleDateTime = getLocaleDateTime;
const getLocalTimeHoursMinutes = (timestamp) => {
    return intlDateTimeFormatHM.format(timestamp);
};
exports.getLocalTimeHoursMinutes = getLocalTimeHoursMinutes;
const getCurrentTime = () => (0, exports.getLocalTime)(Date.now());
exports.getCurrentTime = getCurrentTime;
const getJalaliDateObject = (date) => {
    const stringDate = (0, numbers_1.digitsToLatin)(intlDateTimeFormat.format(date !== null && date !== void 0 ? date : Date.now()));
    const dateArray = stringDate.split("/");
    return {
        year: Number(dateArray[0]),
        month: Number(dateArray[1]),
        day: Number(dateArray[2]),
    };
};
exports.getJalaliDateObject = getJalaliDateObject;
// valid for 1343 to 1472 in Jalali Calendar
const isLeapYear = (year) => [1, 5, 9, 13, 17, 22, 26, 30].includes(year % 33);
exports.isLeapYear = isLeapYear;
const getSaturdayDate = () => {
    const now = new Date();
    const weekDayIndex = now.getDay() === 6 ? 0 : now.getDay() + 1;
    const diff = now.getDate() - weekDayIndex;
    const saturday = new Date(now.setDate(diff));
    const jalaaliSaturday = (0, numbers_1.digitsToLatin)(intlDateTimeFormat.format(saturday));
    const jSaturday = jalaaliSaturday.split("/");
    return {
        year: Number(jSaturday[0]),
        month: Number(jSaturday[1]),
        day: Number(jSaturday[2]),
    };
};
exports.getSaturdayDate = getSaturdayDate;
const getMonthDays = (year, month) => month < 7 ? 31 : month === 12 && !(0, exports.isLeapYear)(year) ? 29 : 30;
exports.getMonthDays = getMonthDays;
const getLocalDateTimeDialog = (timestamp) => {
    const date = new Date(timestamp);
    if (date.toDateString() === new Date().toDateString()) {
        return intlDateTimeFormatHM.format(date);
    }
    else if (date.toDateString() === new Date(Date.now() - exports.OneDayInMS).toDateString()) {
        return "دیروز";
    }
    else {
        const { year, day, month } = (0, exports.getLocalDateObject)(date);
        if (isSecondsElapsedFrom(date, exports.SECONDS_PASSED_IN_A_YEAR))
            return `${day} ${month} ${year}`;
        else
            return `${day} ${month}`;
    }
};
exports.getLocalDateTimeDialog = getLocalDateTimeDialog;
const getCompleteLocalDateTime = (timestamp
//todo: direction?: "rtl" | "ltr"
) => {
    const date = new Date(timestamp);
    const HMFormat = intlDateTimeFormatHM.format(date);
    const splitter = " , ";
    if (date.toDateString() === new Date().toDateString()) {
        return HMFormat;
    }
    else if (date.toDateString() === new Date(Date.now() - exports.OneDayInMS).toDateString()) {
        return fa_1.strings.time.yesterday + splitter + HMFormat;
    }
    else {
        const { year, day, month } = (0, exports.getLocalDateObject)(date);
        if (isSecondsElapsedFrom(date, exports.SECONDS_PASSED_IN_A_YEAR))
            return `${day} ${month} ${year}` + splitter + HMFormat;
        else
            return `${day} ${month}` + splitter + HMFormat;
    }
};
exports.getCompleteLocalDateTime = getCompleteLocalDateTime;
function isSecondsElapsedFrom(date, seconds) {
    return date.getTime() / 1000 + seconds <= Date.now() / 1000;
}
function getTodayDate() {
    const date = jalaali_js_1.default.toJalaali(new Date());
    return {
        year: date.jy,
        month: date.jm,
        day: date.jd,
    };
}
const getLocalDateObject = (d) => {
    var _a, _b, _c;
    const localDateParts = intlDateTimeFormatYMD.formatToParts(d);
    return {
        day: (_a = localDateParts.find(({ type }) => type === "day")) === null || _a === void 0 ? void 0 : _a.value,
        month: (_b = localDateParts.find(({ type }) => type === "month")) === null || _b === void 0 ? void 0 : _b.value,
        year: (_c = localDateParts.find(({ type }) => type === "year")) === null || _c === void 0 ? void 0 : _c.value,
    };
};
exports.getLocalDateObject = getLocalDateObject;
const getLocalDateChat = (timestamp, showYear = false) => {
    const date = new Date(timestamp);
    const { day, month, year } = (0, exports.getLocalDateObject)(date);
    const thisYear = (0, exports.getLocalDateObject)(new Date()).year;
    if (year !== thisYear || showYear) {
        return `${day} ${month} ${year}`;
    }
    return `${day} ${month}`;
};
exports.getLocalDateChat = getLocalDateChat;
const isTodayLastDayOfMonth = () => {
    const { month, day, year } = (0, exports.getJalaliDateObject)();
    const monthDays = (0, exports.getMonthDays)(year, month);
    return monthDays === day;
};
exports.isTodayLastDayOfMonth = isTodayLastDayOfMonth;
const formatSeconds = (total) => {
    const hours = Math.floor(total / (60 * 60));
    const remainingSeconds = total % (60 * 60);
    const minute = Math.floor(remainingSeconds / 60);
    const seconds = Math.floor(remainingSeconds % 60);
    const result = [];
    if (hours > 0) {
        result.push(hours);
    }
    result.push(minute, seconds);
    return result.map((t) => t.toString().padStart(2, "0")).join(":");
};
exports.formatSeconds = formatSeconds;
exports.SecondsInDay = exports.OneDayInMS / 1000;
const formatTimeDuration = (totalSeconds) => {
    if (totalSeconds > exports.SecondsInDay) {
        const days = Math.floor(totalSeconds / exports.SecondsInDay);
        return (0, strings_1.formatStrings)(fa_1.strings.days_remaining, {
            count: (0, numbers_1.digitsToHindi)(days.toString()),
        });
    }
    return (0, numbers_1.digitsToHindi)((0, exports.formatSeconds)(totalSeconds));
};
exports.formatTimeDuration = formatTimeDuration;
const delay = (ms, result) => new Promise((res) => setTimeout(() => res(result), ms));
exports.delay = delay;
const delayReject = (ms) => new Promise((_, rej) => setTimeout(() => rej("Error"), ms));
exports.delayReject = delayReject;
function toGregorian(year, month, day) {
    const gDate = jalaali_js_1.default.toGregorian(year, month, day);
    return new Date(gDate.gy, gDate.gm - 1, gDate.gd);
}
function jalaliCurrentDate() {
    return jalaali_js_1.default.toJalaali(new Date());
}
function getFirstDayOfMonth() {
    const j = jalaliCurrentDate();
    return toGregorian(j.jy, j.jm, 1);
}
function epochToJalai(timestamp) {
    return jalaali_js_1.default.toJalaali(new Date(timestamp));
}
function epochToDateType(timestamp) {
    const jl = jalaali_js_1.default.toJalaali(new Date(timestamp));
    return {
        year: jl.jy,
        month: jl.jm,
        day: jl.jd,
    };
}
var DateTimeType;
(function (DateTimeType) {
    DateTimeType[DateTimeType["MINUTE_AGO"] = 0] = "MINUTE_AGO";
    DateTimeType[DateTimeType["HOUR_AGO"] = 1] = "HOUR_AGO";
    DateTimeType[DateTimeType["TODAY_AGO"] = 2] = "TODAY_AGO";
    DateTimeType[DateTimeType["YESTERDAY_AGO"] = 3] = "YESTERDAY_AGO";
    DateTimeType[DateTimeType["MONTH_AGO"] = 4] = "MONTH_AGO";
    DateTimeType[DateTimeType["YEAR_AGO"] = 5] = "YEAR_AGO";
    DateTimeType[DateTimeType["ELSE_AGO"] = 6] = "ELSE_AGO";
})(DateTimeType || (exports.DateTimeType = DateTimeType = {}));
/** @time is in miliseconds */
const isMonthAgo = (time) => {
    const now = new Date().getTime();
    return now - time < exports.OneDayInMS * 30;
};
exports.isMonthAgo = isMonthAgo;
/** @time is in miliseconds */
const isYearAgo = (time) => {
    const now = new Date().getTime();
    return now - time < exports.OneDayInMS * 365;
};
exports.isYearAgo = isYearAgo;
/** @time is in miliseconds */
const getDateType = (time) => {
    const now = Date.now();
    const dateLooking = new Date(time).getTime();
    const difrence = now - dateLooking;
    const isSecondAgo = difrence < exports.OneMinuteInMS;
    const isMinuteAgo = difrence < exports.OneHourInMS;
    const isTodayAgo = (0, exports.isToday)(time);
    const isYesterdayAgo = (0, exports.isYesterday)(time);
    const _isMonthAgo = (0, exports.isMonthAgo)(time);
    const _isYearAgo = (0, exports.isYearAgo)(time);
    if (isSecondAgo) {
        return DateTimeType.MINUTE_AGO;
    }
    else if (isMinuteAgo) {
        return DateTimeType.HOUR_AGO;
    }
    else if (isTodayAgo) {
        return DateTimeType.TODAY_AGO;
    }
    else if (isYesterdayAgo) {
        return DateTimeType.YESTERDAY_AGO;
    }
    else if (_isMonthAgo) {
        return DateTimeType.MONTH_AGO;
    }
    else if (_isYearAgo) {
        return DateTimeType.YEAR_AGO;
    }
    else {
        return DateTimeType.ELSE_AGO;
    }
};
exports.getDateType = getDateType;
/** @times are in miliseconds */
const getDiffrenceTwoTime = (time1, time2) => {
    const diffrence = Math.floor(Math.abs(time1 - time2));
    const remainingSeconds = Math.floor(diffrence / exports.OneSecondInMS) % exports.OneSecondInMS;
    const remainingMinutes = Math.floor(diffrence / exports.OneMinuteInMS) % exports.OneMinuteInMS;
    const remainingHours = Math.floor(diffrence / exports.OneHourInMS) % exports.OneHourInMS;
    return {
        seconds: remainingSeconds,
        minutes: remainingMinutes,
        hours: remainingHours,
    };
};
exports.getDiffrenceTwoTime = getDiffrenceTwoTime;
function jalaliToEpoch(date, tillNight = false) {
    const gregorianTime = toGregorian(date.year, date.month, date.day);
    if (tillNight)
        return new Date(gregorianTime.setHours(23, 59, 59, 999)).getTime();
    return gregorianTime.getTime();
}
function isFirstDateGraterThanSecondDate(date1, date2) {
    return jalaliToEpoch(date1) > jalaliToEpoch(date2);
}
function formatJalaliDate(date) {
    return (0, numbers_1.digitsToHindi)(`${(0, strings_1.padZero)(date.year, 4)}/${(0, strings_1.padZero)(date.month, 2)}/${(0, strings_1.padZero)(date.day, 2)}`);
}
const isDateToday = (date) => {
    const today = jalaliCurrentDate();
    return (today.jd === date.day && today.jm === date.month && today.jy === date.year);
};
exports.isDateToday = isDateToday;
const isDateFirstDayOfMonth = (date) => {
    const today = jalaliCurrentDate();
    return date.day === 1 && today.jm === date.month && today.jy === date.year;
};
exports.isDateFirstDayOfMonth = isDateFirstDayOfMonth;
const isDateFor30DaysAgo = (date) => {
    const theDate = (0, exports.getJalaliDateObject)(Date.now() - 29 * exports.OneDayInMS);
    return (date.day === theDate.day &&
        date.month === theDate.month &&
        date.year === theDate.year);
};
exports.isDateFor30DaysAgo = isDateFor30DaysAgo;
const isToday = (time) => {
    const theDay = (0, exports.getJalaliDateObject)(time);
    const today = (0, exports.getJalaliDateObject)();
    return (theDay.day === today.day &&
        theDay.month === today.month &&
        theDay.year === today.year);
};
exports.isToday = isToday;
const isYesterday = (time) => {
    const theDay = (0, exports.getJalaliDateObject)(time);
    const today = (0, exports.getJalaliDateObject)();
    return (today.day - theDay.day === 1 &&
        theDay.month === today.month &&
        theDay.year === today.year);
};
exports.isYesterday = isYesterday;
const formatEpoch = (time) => {
    return (0, exports.getLocaleDateTime)(time).replace("،", " - ").slice(0, -3);
};
exports.formatEpoch = formatEpoch;
const compareDateType = (firstDateType, secondDateType) => {
    if (firstDateType.year > secondDateType.year) {
        return 1;
    }
    else if (firstDateType.year < secondDateType.year) {
        return -1;
    }
    if (firstDateType.month > secondDateType.month) {
        return 1;
    }
    else if (firstDateType.month < secondDateType.month) {
        return -1;
    }
    if (firstDateType.day > secondDateType.day) {
        return 1;
    }
    else if (firstDateType.day < secondDateType.day) {
        return -1;
    }
    return 0;
};
exports.compareDateType = compareDateType;
const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 4 * WEEK; // eslint-disable-line @typescript-eslint/no-unused-vars
const rawPersianToEpoch = (text) => jalaliToEpoch({
    year: Number((0, numbers_1.digitsToLatin)(text.split("/")[0])),
    month: Number((0, numbers_1.digitsToLatin)(text.split("/")[1])),
    day: Number((0, numbers_1.digitsToLatin)(text.split("/")[2])),
});
exports.rawPersianToEpoch = rawPersianToEpoch;
const getRelativeTime = (date) => {
    if (date === undefined)
        return "";
    const now = Date.now() / 1000;
    if (MINUTE > now - date) {
        return fa_1.strings.time.now;
    }
    else if (HOUR > now - date) {
        const minutes = Math.floor((now - date) / MINUTE);
        return `${(0, numbers_1.digitsToHindi)(minutes.toString())} ${fa_1.strings.time.minute} ${fa_1.strings.time.before}`;
    }
    else {
        const hours = Math.floor((now - date) / HOUR);
        return `${(0, numbers_1.digitsToHindi)(hours.toString())} ${fa_1.strings.time.hour} ${fa_1.strings.time.before}`;
    }
};
exports.getRelativeTime = getRelativeTime;
function getRelativeDate(timestamp) {
    const seconds = Math.floor(Date.now() - timestamp);
    if (seconds < exports.OneMinuteInMS) {
        return `${seconds} ${fa_1.strings.time.second} ${fa_1.strings.time.before}`;
    }
    if (seconds < exports.OneHourInMS) {
        return `${Math.floor(seconds / exports.OneMinuteInMS)} ${fa_1.strings.time.minute} ${fa_1.strings.time.before}`;
    }
    if (seconds < exports.OneDayInMS) {
        return `${Math.floor(seconds / exports.OneHourInMS)} ${fa_1.strings.time.hour} ${fa_1.strings.time.before}`;
    }
    if (seconds < exports.OneWeekInMS) {
        return `${Math.floor(seconds / exports.OneDayInMS)} ${fa_1.strings.time.day} ${fa_1.strings.time.before}`;
    }
    if (seconds < exports.OneMonthInMS) {
        return `${Math.floor(seconds / exports.OneWeekInMS)} ${fa_1.strings.time.week} ${fa_1.strings.time.before}`;
    }
    return formatJalaliDate(epochToDateType(timestamp));
}
const convertDurationToText = (duration) => {
    const seconds = Math.trunc(duration / 1000);
    if (seconds < MINUTE) {
        return (0, numbers_1.digitsToHindi)(seconds.toString() + " " + fa_1.strings.time.second);
    }
    const minutes = Math.trunc(seconds / MINUTE);
    if (minutes < HOUR) {
        return (0, numbers_1.digitsToHindi)(minutes.toString() + " " + fa_1.strings.time.minute);
    }
    const hours = Math.trunc(seconds / HOUR);
    if (hours < DAY) {
        return (0, numbers_1.digitsToHindi)(hours.toString() + " " + fa_1.strings.time.hour);
    }
    const days = Math.trunc(seconds / DAY);
    return (0, numbers_1.digitsToHindi)(days.toString() + " " + fa_1.strings.time.day);
};
exports.convertDurationToText = convertDurationToText;
class RealDate {
    static getInstance() {
        if (!this.instance) {
            this.instance = new RealDate();
        }
        return this.instance;
    }
    constructor() {
        this.UTCRealTimeDiff = 0;
        this.getRealUTCTimeDiff();
    }
    //todo: add a way to do this for slow internets and add mutex lock for this function.
    async getRealUTCTimeDiff() {
        const startDate = Date.now();
        this.UTCRealTimeDiff = await fetch("https://worldtimeapi.org/api/timezone/UTC")
            .then((res) => res.json())
            .then((data) => {
            const key = "datetime";
            if (key in data) {
                const dateTime = data[key];
                const now = Date.now();
                const RTT = now - startDate;
                const currentDate = new Date(dateTime).getTime() + RTT / 2;
                const diff = currentDate - now;
                if (Math.abs(diff) > 3000) {
                    window.console.warn("RealTime", "server and local time gap is more than 3000 milliseconds", diff);
                    return diff;
                }
                return 0;
            }
            else
                throw new Error("no dateTime");
        })
            .catch((error) => {
            window.console.error("getting UTC time failed", error);
            return 0;
        });
    }
    get diff() {
        return this.UTCRealTimeDiff;
    }
    get Date() {
        const diff = this.UTCRealTimeDiff;
        return new Date(diff + Date.now());
    }
}
exports.RealDate = RealDate;
//# sourceMappingURL=time.js.map